import React, { useEffect, useRef } from 'react';
interface DevicePreviewProps {
  kind: 'phone' | 'tablet';
  scale: number;
  children: React.ReactNode;
}
const SIZES = {
  phone: {
    w: 380,
    h: 800,
    bezel: 10,
    radius: 52,
    innerRadius: 42
  },
  tablet: {
    w: 1180,
    h: 800,
    bezel: 18,
    radius: 44,
    innerRadius: 28
  }
};

/** Renders a live, non-interactive Snak at native size inside a device frame, scaled down. */
export function DevicePreview({
  kind,
  scale,
  children
}: DevicePreviewProps) {
  const s = SIZES[kind];
  const screenRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    screenRef.current?.setAttribute('inert', '');
  }, []);
  const outerW = s.w + s.bezel * 2;
  const outerH = s.h + s.bezel * 2;
  return <div style={{
    width: outerW * scale,
    height: outerH * scale
  }} className="relative" data-id="element-319" data-mp="3gefblz6t5v5l">
      <div className="absolute left-0 top-0 origin-top-left bg-navy-900 shadow-[0_40px_90px_-30px_rgba(15,36,66,0.45)]" style={{
      width: outerW,
      height: outerH,
      padding: s.bezel,
      borderRadius: s.radius,
      transform: `scale(${scale})`
    }} data-id="element-320" data-mp="7yvprl8gvf0k">
        <div ref={screenRef} className="pointer-events-none relative h-full w-full select-none overflow-hidden bg-white" style={{
        borderRadius: s.innerRadius
      }} aria-hidden="true" data-id="element-321" data-mp="35f4mycwf86lv">
          {kind === 'phone' && <div className="absolute left-1/2 top-2.5 z-40 h-6 w-28 -translate-x-1/2 rounded-full bg-navy-900" data-id="element-322" data-mp="3afk2nb46dq70" />}
          {children}
        </div>
      </div>
    </div>;
}